import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";

export const dataGridStylesAvisos = (colors) => ({
  "& .MuiDataGrid-root": {
    border: "none",
    fontWeight: "bold",
  },
  "& .name-column--cell": {
    color: colors.greenAccent[300],
    fontWeight: "bold",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: colors.gov[500],
    fontWeight: "bold",
    color: "#ffffff",
  },
  "& .MuiDataGrid-virtualScroller": {
    backgroundColor: colors.primary[400],
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "none",
    backgroundColor: colors.gov[600],
    color: "#ffffff",
    fontWeight: "bold",
  },
  "& .MuiTablePagination-root": {
    color: "white",
    fontWeight: "bold",
  },
  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
    color: `${colors.grey[100]} !important`,
  },
});

export const dataGridStyles = (colors) => ({
  "& .MuiDataGrid-root": {
    border: "none",
    fontWeight: "bold",
  },
  "& .name-column--cell": {
    color: colors.gov[400],
    fontWeight: "bold",
  },
  "& .normativa-column--cell": {
    cursor: "pointer",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: colors.gov[500],
    fontWeight: "bold",
    color: "#ffffff",
  },
  "& .MuiDataGrid-virtualScroller": {
    backgroundColor: colors.primary[400],
  },
  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: colors.gov[900],
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: colors.primary[400],
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: `${colors.gov[800]} !important`,
  },
  "& .MuiDataGrid-cell": {
    borderBottom: `1px solid ${colors.gov[900]}`,
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "none",
    backgroundColor: colors.gov[600],
    color: "#ffffff",
  },
  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
    color: `${colors.grey[100]} !important`,
  },
  "& .MuiCheckbox-root": {
    color: `${colors.greenAccent[200]} !important`,
  },
  gridColumn: "span 12",
});

export const stepperStyles = (activeStep, index) => ({
  "& .MuiStepLabel-label.Mui-active": {
    color: "secondary.main", // Color del label cuando el paso está activo
    fontWeight: "bold", // Negrita cuando está activo
  },
  "& .MuiStepLabel-label": {
    color: activeStep === index ? "secondary.main" : "text.disabled",
    fontWeight: activeStep === index ? "bold" : "normal", // Negrita si es el paso activo
  },
  "& .MuiStepIcon-root.Mui-active": {
    color: "secondary.main", // Color del icono cuando el paso está activo
  },
  "& .MuiStepIcon-root": {
    color: activeStep === index ? "secondary.main" : "text.disabled", // Color del icono cuando está activo/inactivo
  },
});

export const CustomDatePicker = styled(DatePicker)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: theme.palette.secondary,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.secondary.dark,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.secondary.dark,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.secondary.dark,
    },
  },
  "& .MuiIconButton-root": {
    color: theme.palette.secondary.main,
  },
}));
